import { render } from "./uk-form.vue?vue&type=template&id=757e3b45"
import script from "./uk-form.vue?vue&type=script&lang=js"
export * from "./uk-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__